import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=78843c6b&scoped=true&"
var script = {}
import style0 from "./Info.vue?vue&type=style&index=0&id=78843c6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78843c6b",
  null
  
)

export default component.exports